"use client";

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import logo from '../../../../public/logo.png';
import NavBar from "./nav-bar";

export default function PageHeader() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavigation = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className="page-header fixed-top">
            <div className="top-bar">
         <span>
                    <p>Independent Insurance Price Searching Company</p>
                    <hr/>
                    <a href="tel:01517095888" className="ms-2">
                        <i className="fas fa-phone"></i> 
                        01517095888
                    </a>
                </span>
            </div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container">
                    <Link className="navbar-brand" href="/" onClick={() => handleNavigation('/')}>
                        {/*
                          logo.jpeg is 1536×1024; audits showed it rendered ~243×60 while srcset stayed large.
                          Lock layout + sizes so next/image emits ~243w (and ~2× for retina), not wallpaper-sized widths.
                          priority: navbar logo is above-the-fold — avoid lazy (hurts LCP).
                        */}
                        <Image
                            src={logo}
                            alt="ICUK Insurance"
                            width={400}
                            height={100}
                            sizes="243px"
                            priority
                            className="header-logo d-inline-block align-top me-2"
                            style={{ objectFit: "contain" }}
                        />
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleMenu}
                        aria-controls="navbarNavDropdown"
                        aria-expanded={isMenuOpen}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className={`collapse navbar-collapse justify-content-end ${isMenuOpen ? 'show' : ''}`}
                        id="navbarNavDropdown">
                        <NavBar
                            handleNavigation={handleNavigation}
                        />
                    </div>
                </div>
            </nav>
        </header>
    );
}